<template>
  <div
    class="py-5 d-flex flex-column justify-content-center align-items-center"
  >
    <em class="fas fa-check-circle color-primary-1" style="font-size: 50px" />
    <div class="color-black-1 font-18 mt-4 text-center">
      {{ $t('YourPasswordHasBeenChanged') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPasswordFinalize',
  data: () => ({
    model: {},
  }),
};
</script>
